import { render, staticRenderFns } from "./ChecksGroup.vue?vue&type=template&id=4b38374c&scoped=true"
import script from "./ChecksGroup.vue?vue&type=script&lang=js"
export * from "./ChecksGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38374c",
  null
  
)

export default component.exports